import { createFileRoute, Link } from "@tanstack/react-router";

export const Route = createFileRoute("/soins-energetiques-toulouse")({
  head: () => ({
    meta: [
      { title: "Soins énergétiques à Toulouse | Rénergescence" },
      { name: "description", content: "Soins énergétiques à Toulouse pour rééquilibrer vos énergies, libérer les blocages et soutenir un mieux-être durable. En cabinet ou à distance." },
      { property: "og:title", content: "Soins énergétiques à Toulouse — Rénergescence" },
      { property: "og:description", content: "Rééquilibrage énergétique et libération des blocages à Toulouse." },
      { property: "og:url", content: "/soins-energetiques-toulouse" },
    ],
    links: [{ rel: "canonical", href: "https://renergescence.com/soins-energetiques-toulouse" }],
  }),
  component: Page,
});

function Page() {
  return (
    <>
      <section className="pt-20 pb-12 md:pt-28">
        <div className="mx-auto max-w-3xl px-6 text-center">
          <p className="eyebrow">Magnétisme · Rééquilibrage · Libération</p>
          <h1 className="mt-5 font-display text-4xl font-light italic md:text-6xl">Soins énergétiques à Toulouse</h1>
          <p className="mx-auto mt-6 max-w-2xl text-base leading-relaxed md:text-lg" style={{ color: "var(--color-muted-foreground)" }}>
            Au cabinet Rénergescence, les soins énergétiques accompagnent le rééquilibrage du corps et de l'esprit, la libération des blocages et la restauration d'un mieux-être durable.
          </p>
          <Link to="/contact" className="mt-8 inline-block rounded-full px-8 py-4 text-sm font-medium text-white" style={{ backgroundColor: "#7A8A76" }}>
            Prendre rendez-vous
          </Link>
        </div>
      </section>

      <section className="py-16 md:py-20" style={{ backgroundColor: "var(--color-surface)" }}>
        <div className="mx-auto grid max-w-[1100px] gap-10 px-6 md:grid-cols-3">
          {[
            { t: "Rééquilibrage énergétique", d: "Harmonisation des centres énergétiques, retour à une circulation fluide de l'énergie vitale." },
            { t: "Libération des blocages", d: "Identification et dénouement des nœuds énergétiques qui freinent votre vitalité ou votre clarté." },
            { t: "Soin thérapeutique d'accompagnement", d: "Un soutien complémentaire pour les périodes de transition, de fatigue ou de convalescence." },
          ].map((c) => (
            <article key={c.t} className="rounded-3xl border bg-white p-7" style={{ borderColor: "#e8e0d8" }}>
              <h2 className="font-display text-xl" style={{ color: "#2D2B28" }}>{c.t}</h2>
              <p className="mt-3 text-[15px] leading-relaxed" style={{ color: "var(--color-text)" }}>{c.d}</p>
            </article>
          ))}
        </div>
      </section>

      <section className="py-16 md:py-20">
        <div className="mx-auto max-w-[820px] px-6">
          <h2 className="font-display text-3xl font-light md:text-4xl">À qui s'adressent les soins énergétiques ?</h2>
          <ul className="mt-6 space-y-3 text-[15px] leading-relaxed" style={{ color: "var(--color-text)" }}>
            <li>• Toute personne ressentant un état de fatigue, de stress ou de surcharge mentale</li>
            <li>• Personnes traversant une période de transition (deuil, séparation, changement professionnel)</li>
            <li>• Accompagnement complémentaire à un suivi médical ou en <Link to="/prestations" hash="naturopathie" className="underline">naturopathie</Link></li>
            <li>• Femmes enceintes (sur avis et hors contre-indications)</li>
          </ul>
          <p className="mt-6 text-sm italic" style={{ color: "var(--color-muted-foreground)" }}>
            Les soins énergétiques sont une pratique de bien-être complémentaire qui ne remplace en aucun cas un avis ou un traitement médical.
          </p>
          <div className="mt-10 flex flex-wrap gap-3">
            <Link to="/tarifs-soins" className="rounded-full px-5 py-2 text-sm text-white" style={{ backgroundColor: "#7A8A76" }}>Voir les tarifs</Link>
            <Link to="/contact" className="rounded-full border px-5 py-2 text-sm" style={{ borderColor: "#7A8A76", color: "var(--color-sage-text)" }}>Réserver ma séance</Link>
          </div>
        </div>
      </section>
    </>
  );
}